import _ from 'lodash';

const getDeductibleDisplayInfo = (deductibleTerm, limitTerm) => {
    const {chosenTermValue} = deductibleTerm;
    // added flatAmount to handle $100, $200 etc
    const {percent, flatAmount, minimum} = parseDeductible();
    const deductibleAmount = percent ? limitTerm?.directValue * (percent / 100) : flatAmount || limitTerm?.directValue;

    return `$${(deductibleAmount < minimum) ? minimum : deductibleAmount}`;


    /**
     * Handles the parsing of deductible display's into percent and minimum or flat amount
     * Ex: 2% (1000 min), 5%, $100
     * @returns {{percent: undefined, minimum: number}|{percent: number, minimum: number}|{flatAmount: string, percent: undefined, minimum: number}}
     */
    function parseDeductible() {
        if (RegExp(/^\d% [(][$]\d{3,4} min[)]$/).test(chosenTermValue)) { // Match Pattern 1% ($1000 min) or 1% ($100 min)
            return {
                percent: parseInt(chosenTermValue.substr(0, 1)),
                flatAmount: undefined,
                minimum: parseInt(chosenTermValue.substr(5, 4).trim())
            };
        } else if (RegExp(/^[1-9]\d*(\.\d+)?%$/).test(chosenTermValue)) { // handle '%'. Match Pattern 5%, 1.5%
            return {
                percent: _.toNumber(chosenTermValue.replace('%', '')), // correctly handle floats
                flatAmount: undefined,
                minimum: 0
            };
        } else if (RegExp(/^[$](\d+)$/).test(chosenTermValue)) { // Match $100  $1000 etc.
            return {
                percent: undefined,
                flatAmount: chosenTermValue.substr(1, chosenTermValue.length - 1),
                minimum: undefined
            };
        } else if (!_.isNaN(chosenTermValue)) { //  blanket deductible is an integer.  Match Pattern 5, 1.5
            return {
                percent: _.toNumber(chosenTermValue), // correctly handle floats
                flatAmount: undefined,
                minimum: 0
            };
        }
        return {
            percent: undefined,
            flatAmount: undefined,
            minimum: 0
        };
    }
}

export default {
    'getDeductibleDisplayInfo': getDeductibleDisplayInfo,
}
